export default "__VITE_ASSET__590c86f7__"